<template>
  <div class="release-main-page">
    <main-header :hasBanner="true"></main-header>
    <section class="main-center">
      <div class="r-title">个人房源查询挂牌</div>
      <el-form ref="form" :model="form" :rules="rules" label-width="150px">
        <el-row>
          <el-col :span="24">
            <el-form-item label="岗位状态" prop="">
              <el-radio-group v-model="form.type">
                <el-radio label="1">不动产权证书</el-radio>
                <el-radio label="2">房屋所有权证</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="产权证号" prop="code">
              <el-input v-model="form.code" placeholder="请输入产权证号" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="姓名" prop="name">
              <el-input v-model="form.name" placeholder="产权人名称" />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item label="证件类型" prop="sex">
              <el-select v-model="form.sex" placeholder="请选择证件类型">
                <el-option
                  v-for="dict in typeList"
                  :key="dict.value"
                  :label="dict.label"
                  :value="dict.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="证件号码" prop="code">
              <el-input v-model="form.code" placeholder="请输入证件号码" />
            </el-form-item>
          </el-col>
        </el-row>

        <div class="btn-box">
          <el-button type="primary">房源查询</el-button>
        </div>

        <el-row>
          <el-col :span="12">
            <el-form-item label="通知电话" prop="noticePhone">
              <el-input
                v-model="form.noticePhone"
                placeholder="请输入通知电话"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="发布电话" prop="releasePhone">
              <el-input
                v-model="form.releasePhone"
                placeholder="请输入发布电话"
              />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item label="房屋坐落及小区名称" prop="communityName">
              <el-input
                v-model="form.communityName"
                placeholder="房屋坐落信息将对外公示，请勿填写详细信息。"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="重点区域" prop="keyArea">
              <el-input v-model="form.keyArea" placeholder="请输入重点区域" />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item label="街道" prop="street">
              <el-input v-model="form.street" placeholder="请输入街道" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="建筑年代" prop="builtYear">
              <el-input v-model="form.builtYear" placeholder="请输入建筑年代" />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item label="朝向" prop="orientation">
              <el-input v-model="form.orientation" placeholder="请输入朝向" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="总层数" prop="totalNumber">
              <el-input v-model="form.totalNumber" placeholder="请输入总层数" />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item label="户型" prop="houseType">
              <el-select v-model="form.houseType" placeholder="请选择户型">
                <el-option
                  v-for="dict in typeList"
                  :key="dict.value"
                  :label="dict.label"
                  :value="dict.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="装修标准" prop="decorationStandard">
              <el-select
                v-model="form.decorationStandard"
                placeholder="请选择装修标准"
              >
                <el-option
                  v-for="dict in typeList"
                  :key="dict.value"
                  :label="dict.label"
                  :value="dict.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item label="行政区" prop="administrativeRegion">
              <el-select
                v-model="form.administrativeRegion"
                placeholder="请选择行政区"
              >
                <el-option
                  v-for="dict in typeList"
                  :key="dict.value"
                  :label="dict.label"
                  :value="dict.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="房屋出售" prop="isSell">
              <el-radio-group v-model="form.isSell">
                <el-radio label="1">否</el-radio>
                <el-radio label="2">是</el-radio>
              </el-radio-group>
              <el-input
                :disabled="form.isSell != 2"
                v-model="form.houseprice"
                placeholder="拟售价格"
              />
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="房屋出租" prop="isRent">
              <el-radio-group v-model="form.isRent">
                <el-radio label="1">否</el-radio>
                <el-radio label="2">是</el-radio>
              </el-radio-group>
              <el-input
                :disabled="form.isRent != 2"
                v-model="form.rentPrice"
                placeholder="出租价格(元/月)"
              />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="20">
            <el-form-item label="身份证件上传" prop="idImgUrl">
              <image-upload v-model="form.idImgUrl" :limit="1"></image-upload>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="20">
            <el-form-item label="房产证件上传" prop="estateImgUrl">
              <image-upload
                v-model="form.estateImgUrl"
                :limit="1"
              ></image-upload>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
     <div class="btn-box">
          <el-button type="primary">提交</el-button>
        </div>
    </section>
    <main-footer></main-footer>
  </div>
</template>

<script>
import mainHeader from "@/components/mainHeader";
import mainFooter from "@/components/mainFooter";
import ImageUpload from "@/components/imageUpload";
import { resourcesDetail } from "@/assets/api/resources";
export default {
  name: "Release",
  components: {
    mainHeader,
    mainFooter,
    ImageUpload,
  },

  data() {
    return {
      form: {},
      rules: {},
      typeList: [],
    };
  },
  computed: {},
  mounted() {},
  methods: {
    goRelease() {},
  },
};
</script>

<style lang="less">
.release-main-page {
  background: #fff;

  .r-title {
    font-size: 26px;
    padding-bottom: 20px;
    margin-bottom: 10px;
    text-align: center;
    border-bottom: 1px solid #eee;
  }
  .el-form-item .el-select {
    width: 100%;
  }

  .btn-box {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 6px 0 42px;
    button {
      background: #b1191a;
      border: none;
    }
  }

  .mg-t20 {
    margin-top: 20px;
  }
  #mapBox {
    width: 100%;
    height: 500px;
  }
}
</style>